import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // ✅ You can KEEP StrictMode for development safety
  // ❗ If you feel effects run twice while testing, it is normal
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
